module.exports = __webpack_public_path__ + "static/glutenFree-2d390726d916f97252fcb3271198f9c1.png";